<template>
  <div class="marTL marBL padTL padBL padLL padRL"
       style="max-width:710px;margin-left:auto;margin-right:auto;border:3px solid #d5d5d5;">

    <div class="clearfix">
      <h2 class="floL fntP fntL bolder" style="padding:0px;color:#1874cd;">
                            <span class="disIb marRS" style="vertical-align:middle;">
                                <img src="../img/joinIcon_a.png" alt="">
                            </span>항공일정
      </h2>
      <span class="disIb pcOnly" style="float:right;background-color:#fcfcfc;padding:0.1em 0.7em;color:#666;text-align:right;border:1px solid #bebdbd;">
        <a href="#" @click.prevent="$emit('printScr')" style="text-decoration:none;">인쇄</a>
      </span>
    </div>

    <div>
      <div class="marTM marBM padTM" style="border-top:1px solid #d5d5d5;">
        <p class="marTS fntH6 fntL txtC bolder" style="background-color:#ebf5ff;padding:0.8em;color:#1874cd;">
          <img src="../img/joinIcon_ab.png" alt="" style="padding-right:0.3em;vertical-align:text-bottom;">출국일정
        </p>
      </div>
      <div class="clearfix fntP">
        <div style="border:1px solid #d5d5d5;">
          <p class="clearfix" style="padding:0.8em;">
            <span class="floL bolder moTxtC" style="width:30%;font-size:1.2em;">출발</span>
            <span class="floR moTxtC"
                  style="width:70%;text-align:right;vertical-align:text-bottom;">예약번호 : {{scheduleList[0].mas_departure_reserved_number}}</span>
          </p>
          <p class="fntH5 txtC bolder"
             style="background-color:#f5f5f5;padding:0.5em 0em;border-top:1px solid #d5d5d5;border-bottom:1px solid #d5d5d5;">
            {{scheduleList[0].mas_departure_flight}}
          </p>

          <div class="flightTimeInfo" style="width:100%;min-height:auto;border:0px;overflow:hidden;">
            <div class="leftDiv">
              <strong style="color:#1874cd;">{{scheduleList[0].mas_departure_start}}</strong>
              <strong style="margin:0.2em 0em;"><span>{{scheduleList[0].mas_departure_start_date}}</span></strong>
              <strong style="color:#1874cd;">{{scheduleList[0].mas_departure_start_time}}</strong>
            </div>
            <div class="rightDiv">
              <strong style="color:#1874cd;">{{scheduleList[0].mas_departure_end}}</strong>
              <strong style="margin:0.2em 0em;"><span>{{scheduleList[0].mas_departure_end_date}}</span></strong>
              <strong style="color:#1874cd;">{{scheduleList[0].mas_departure_end_time}}</strong>
            </div>
          </div>

          <p class="padTS padBM"
             style="width:90%;margin:0px auto;font-size:0.9em;border-top:1px solid #d5d5d5;"><b>비고 : {{scheduleList[0].mas_departure_remarks}}</b></p>
        </div>
      </div>
    </div>

    <div class="marTL marBM padTL" style="border-top:1px solid #d5d5d5;">
      <div class="marBM">
        <p class="fntH6 fntL txtC bolder" style="background-color:#ebf5ff;padding:0.8em;color:#1874cd;">
          <img src="../img/joinIcon_ab2.png" alt="" style="padding-right:0.3em;vertical-align:text-bottom;">입국일정
        </p>
      </div>
      <div class="clearfix fntP">
        <div style="border:1px solid #d5d5d5;">
          <p class="clearfix" style="padding:0.8em;">
            <span class="floL bolder moTxtC" style="width:30%;font-size:1.2em;">도착</span>
            <span class="floR moTxtC"
                  style="width:70%;text-align:right;vertical-align:text-bottom;">예약번호 : {{scheduleList[0].mas_return_reserved_number}}</span>
          </p>
          <p class="fntH5 txtC bolder"
             style="background-color:#f5f5f5;padding:0.5em 0em;border-top:1px solid #d5d5d5;border-bottom:1px solid #d5d5d5;">
            {{scheduleList[0].mas_return_flight}}</p>

          <div class="flightTimeInfo" style="width:100%;min-height:auto;border:0px;overflow:hidden;">
            <div class="leftDiv">
              <strong style="color:#1874cd;">{{scheduleList[0].mas_return_start}}</strong>
              <strong style="margin:0.2em 0em;"><span>{{scheduleList[0].mas_return_start_date}}</span></strong>
              <strong style="color:#1874cd;">{{scheduleList[0].mas_return_start_time}}</strong>
            </div>
            <div class="rightDiv">
              <strong style="color:#1874cd;">{{scheduleList[0].mas_return_end}}</strong>
              <strong style="margin:0.2em 0em;"><span>{{scheduleList[0].mas_return_end_date}}</span></strong>
              <strong style="color:#1874cd;">{{scheduleList[0].mas_return_end_time}}</strong>
            </div>
          </div>

          <p class="padTS padBM"
             style="width:90%;margin:0px auto;font-size:0.9em;border-top:1px solid #d5d5d5;"><b>비고 : {{scheduleList[0].mas_return_remarks}}</b></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MasInternationalSchdule',
  props: {
    scheduleList: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
@import '../css/font_kr.css';
@import '../css/content_res_reset.css';
@import '../css/content_res_all.css';
@import '../css/content_oad_flight.css';
</style>



// WEBPACK FOOTER //
// src/views/nca/components/masInternationalSchedule.vue